import React from 'react';

const PortfolioPageHeroImage = ({ imageInfo, classes, children, location }) => {
  const { childImageSharp } = imageInfo;
  const portfolioBannerImage = typeof window === "undefined" ? null : window.localStorage.getItem(
    'portfolioBannerImage'
  );
  const getImageSource = () => {
    if (location.search === '') {
      if (!!imageInfo && !!imageInfo.childImageSharp) {
        return `url(${imageInfo.childImageSharp.fluid.src})`;
      }
      if (!!childImageSharp) {
        return `url(${childImageSharp.fluid.src})`;
      }
      if (!!imageInfo && typeof imageInfo === 'string') {
        return `url(${imageInfo})`;
      }
      return null;
    } else {
      if (portfolioBannerImage && portfolioBannerImage !== '') {
        return portfolioBannerImage;
      } else {
        return `url(${imageInfo})`;
      }
    }
  };

  return (
    <div
      className={classes}
      style={{
        backgroundSize: 'cover',
        backgroundImage: getImageSource(),
        position: 'relative',
      }}>
      {children}
    </div>
  );
};

export default PortfolioPageHeroImage;
